(function () {
    angular.module('ui2.0Service').factory('insightService', ['$http', '$rootScope', '$compile', '$window',function ($http, $rootScope, $compile, $window){

        let retObj = {
            "allSelectedInsights" : [],
            "allNonSelectedInsights" : [],
            "tempAllSelectedInsights" : [],
            "_allInsights" : [],
            "allSelected" : false,
            "searchText" : "",
            "sortableOptions" : {
                stop: function (e, ui) {
                    for (var index in retObj.tempAllSelectedInsights) {
                        retObj.tempAllSelectedInsights[index].userOrderSeq = Number(index) + 1;
                    }
                }
            },
            "index":0,
            "slidesToShow" : 5
        }
        let insightComputationId = '';

        return{
            toggleToInsightView : toggleToInsightView,
            showInsightSelectionPopup: showInsightSelectionPopup,
            selectInsight: selectInsight,
            viewSelectedInsights: viewSelectedInsights,
            getInsightLink: getInsightLink,
            selectAll: selectAll,
            deselectAll: deselectAll,
            selectedOrDeselectAll: selectedOrDeselectAll,
            closeDialog: closeDialog,
            deselect: deselect,
            getCurrentInsightIndex:getCurrentInsightIndex,
            insightSettings : insightSettings,
            setInsightComputationId: setInsightComputationId,
            retObj : retObj,
        }

        function toggleToInsightView(event,dataToSend){
            let self = this;
            let insightUrl;
            if(dataToSend ||( self.insightComputationId == "" && $rootScope.listInsightLoaded == "true")) {
                if(self.insightComputationId && !_.isEmpty($rootScope.allInsights)){
                    insightUrl = appName + '/insights/list/'+listId+'/'+self.insightComputationId+'/getInsightDetailsByComputationId';
                } else {
                    insightUrl = appName + '/insights/filtered-entity-list';
                }
                var _dataSend = JSON.parse(dataToSend);
                if(!dataToSend || _.isEmpty(_dataSend.filterMap)|| _.isEmpty(_dataSend.filterMap.filterJson)|| (self.insightComputationId == "" && $rootScope.listInsightLoaded == "true" && !dataToSend)){
                    let data = {
                        "filterMap" : {}
                    };
                    if(insightUrl.indexOf('getInsightDetailsByComputationId') == -1){
                        data.filterMap["entityTypeId"] =  listJson.entityTypeId
                    }
                    dataToSend = JSON.stringify(data);
                }
                $http({
                    url: insightUrl,
                    method: 'POST',
                    data: dataToSend
                }).then(function successCallback(response) {
                    self.insightDataReceived = true;
                    if (_.isEmpty(response.data)) {
                        $rootScope.listInsights = [];
                        return;
                    }
                    if(!_.isEmpty($rootScope.allInsights) && !_.isEmpty($rootScope.listInsights)){
                        if(insightUrl.indexOf('getInsightDetailsByComputationId') != -1){
                            $rootScope.allInsights = $rootScope.allInsights.map(ins =>{
                                ins.ftlData = ins.orgFtlData;
                                return ins;
                            })
                            var index = $rootScope.allInsights.findIndex( (ins)=>ins.insightComputationId == response.data.insightComputationId);
                            $rootScope.allInsights[index].ftlData = response.data.ftlData;
                            $rootScope.allInsights[index].orgFtlData = response.data.ftlData;
                            $rootScope.listInsights = $rootScope.listInsights.map(ins =>{
                                ins.ftlData = ins.orgFtlData;
                                return ins;
                            });
                            var index = $rootScope.listInsights.findIndex( (ins)=>ins.insightComputationId == response.data.insightComputationId);
                            $rootScope.listInsights[index].ftlData = response.data.ftlData;
                            $rootScope.listInsights[index].orgFtlData = response.data.ftlData;
                        } else {
                            $rootScope.allInsights = $rootScope.allInsights.map(function (insight) {
                                var newInsightData = response.data[0].insights.find(function (ins) {
                                    return ins.insightComputationId == insight.insightComputationId;
                                });
                                insight.ftlData = newInsightData.ftlData;
                                insight.orgFtlData = insight.ftlData;
                                return insight;
                            });
                            $rootScope.listInsights = $rootScope.listInsights.map(function (insight) {
                                var newInsightData = response.data[0].insights.find(function (ins) {
                                    return ins.insightComputationId == insight.insightComputationId;
                                });
                                insight = newInsightData;
                                insight.orgFtlData = insight.ftlData;
                                return insight;
                            });
                        }
                        insightSettings(self);
                        return;
                    }
                    $rootScope.insightsCollapsed = false;
                    $rootScope.allInsights = [];
                    response.data[0].insights.forEach(function (insightObj) {
                        insightObj.orgFtlData = insightObj.ftlData;
                        $rootScope.allInsights = [...$rootScope.allInsights, insightObj];
                    });
                    retObj.allSelectedInsights = $rootScope.allInsights.filter(insight => insight.userOrderSeq != null).sort((in1, in2) => in1.userOrderSeq - in2.userOrderSeq);

                    retObj.allNonSelectedInsights = $rootScope.allInsights.filter(insight => insight.userOrderSeq == null).sort((in1, in2) => in1.orderSeq - in2.orderSeq);
                    if (!_.isEmpty(retObj.allSelectedInsights)) {
                        $rootScope.listInsights = angular.copy(retObj.allSelectedInsights);
                        $rootScope.allInsights.map(insight => {
                            insight.checked = insight.userOrderSeq ? true : false;
                            return insight;
                        });
                    } else {
                        $rootScope.listInsights = angular.copy(retObj.allNonSelectedInsights);
                        $rootScope.allInsights.map(insight => {
                            insight.checked = true;
                            return insight;
                        });
                    }
                    insightSettings(self);

                }, function errorCallback(response) {
                    $rootScope.listInsights = [];
                });
            }
            else {
                self.insightView = true;
                self.insightDataReceived = true;
                insightSettings(self);
            }
        }

        function showInsightSelectionPopup(){

            sJq.$('#priorityOverlayInsightsListing').dialog({
                autoOpen: false,
                width: 800,
                maxHeight: 500,
                height: 500,
                resizable: false,
                modal: true,
                draggable: true,
                open: function( event, ui ) {
                    initializeFilterInsights();
                    $('[aria-describedby="priorityOverlayInsightsListing"] .ui-dialog-titlebar-close').attr('title',intl_msg[24237]);
                    sJq.$('#priorityOverlayInsightsListing').find(".searchResultPass").focus();
                    resetDialogPosition(this);
                },
                close: function(){
                    sJq.$('#priorityOverlayInsightsListing').dialog('destroy');
                }
            });

            retObj.tempAllSelectedInsights = angular.copy($rootScope.listInsights);
            retObj._allInsights = angular.copy($rootScope.allInsights);
            if(retObj.tempAllSelectedInsights.length == retObj._allInsights.length){
                retObj.allSelected = true;
            }

            sJq.$('#priorityOverlayInsightsListing').dialog('option', 'title', intl_msg[29598] ? intl_msg[29598] : 'Selected Insights' );
            sJq.$('#priorityOverlayInsightsListing').dialog('open');
        }

        function selectInsight(insight){
            if(!insight.checked){
                insight.checked = true;
                retObj.tempAllSelectedInsights.push(insight);
            } else{
                retObj.tempAllSelectedInsights = retObj.tempAllSelectedInsights.filter(function(i){
                    return i.id != insight.id;
                });
                insight.checked = false;
            }
            if(retObj.tempAllSelectedInsights.length == $rootScope.allInsights.length){
                retObj.allSelected = true;
            } else{
                retObj.allSelected = false;
            }
        }

        function viewSelectedInsights() {
            retObj.searchText = "";
            if (retObj.tempAllSelectedInsights.length) {
                retObj.tempAllSelectedInsights.forEach((insight, index) => {
                    insight.userOrderSeq = index + 1;
                });
                $rootScope.listInsights = angular.copy(retObj.tempAllSelectedInsights);
                $rootScope.allInsights = angular.copy(retObj._allInsights);
                sJq.$('#priorityOverlayInsightsListing').dialog('destroy');
                if(insightComputationId){

                    let selectedInsight = retObj.tempAllSelectedInsights.find(insight =>{
                        return insight.insightComputationId == insightComputationId;
                    });
                    if(!selectedInsight){
                        // openInsight(retObj.tempAllSelectedInsights[0]);
                        $rootScope.$broadcast("openInsight",retObj.tempAllSelectedInsights[0]);
                    }
                }

            }
        }

        function getInsightLink(insight){
            return appName+"#/listRender/"+insight.listId+"?insightComputationId="+insight.insightComputationId+"&listInsightLoaded=true";
        }

        function selectAll (){
            retObj._allInsights.map(insight =>{
                if(!insight.checked){
                    insight.checked = true;
                    retObj.tempAllSelectedInsights.push(insight);
                }
                return insight;
            });
            retObj.allSelected = true;
        }

        function deselectAll() {
            retObj._allInsights.map(insight =>{
                if(insight.checked){
                    insight.checked = false;
                    retObj.tempAllSelectedInsights = [];
                }
                return insight;
            })
            retObj.allSelected = false;
        }

        function selectedOrDeselectAll(){

            if(retObj.allSelected){
                deselectAll();
            } else {
                selectAll();
            }
        }

        function closeDialog(){
            retObj.searchText = "";
            retObj.allSelected = false;
            retObj.tempAllSelectedInsights = angular.copy($rootScope.listInsights);
            retObj._allInsights = angular.copy($rootScope.allInsights);
            if(retObj.tempAllSelectedInsights.length == retObj._allInsights.length){
                retObj.allSelected = true;
            }
            sJq.$('#priorityOverlayInsightsListing').dialog('close');
        }

        function deselect(insight){
            retObj._allInsights.map(function (ins) {
                if(ins.id==insight.id){
                    ins.checked = false;
                }
                return ins;
            });
            retObj.tempAllSelectedInsights = retObj.tempAllSelectedInsights.filter(function(i){
                return i.id != insight.id;
            });
        }

        function getCurrentInsightIndex (id) {
            if(id == ""){
                return 0;
            }
            var index =  $rootScope.listInsights.findIndex( (insight)=>{
                return insight.insightComputationId == id;
            });

            if(index == -1 || index == 0) {
                return 0;
            }
            return (Math.floor(index  / retObj.slidesToShow)) * retObj.slidesToShow;
        }

        function insightSettings(self){
            retObj.index = getCurrentInsightIndex(self.insightComputationId);
            setTimeout(function () {
                self.setFilterForInsight();
            }, 50);
            $rootScope.$$postDigest(function () {
                commonUtil.setListTableHeight();
            })
        }

        function setInsightComputationId(id){
            insightComputationId = id
        }
    }]);
})();